const dataCv = [
  /********** RESTAURATION ***************/
  {
    date: "Mai 2021",
    entreprise: "Sca-Ouest ",
    lieu: "Saint-Etienne de Montluc",
    statut: "Préparateur de commande",
    mission: "Préparations des commandes en entrepôt.",
    categorie: "autre",
  },
  {
    date: "Avril 2019 à Février 2020",
    entreprise: "L'Octopus ",
    lieu: "Nantes",
    statut: "Chef de rang ",
    mission:
      "Préparation du service, accueil, prise de commande, encaissement, gestion d'un rang.",
    categorie: "restauration",
  },
  {
    date: " Septembre 2018 à Mars 2019",
    entreprise: "Le French Pub ",
    lieu: "Saint-Sébastien",
    statut: "Serveur",
    mission:
      "Préparation de la salle et du service, envoi des commandes, nettoyage de la salle",
    categorie: "restauration",
  },
  {
    date: "Juin 2018 à Septembe 2018",
    entreprise: "L'Opium ",
    lieu: "Nantes",
    statut: "Serveur / Barman",
    mission:
      "Service et conception des boissons au bar, services des plats en salle",
    categorie: "restauration",
  },
  /********** AUTRE ***************/

  {
    date: "Septembre 2017 à Juin 2018",
    entreprise: "La Coquille ",
    lieu: "Nantes",
    statut: "Buraliste",
    mission: "Vente des produits présents, gestion des conflits",
    categorie: "autre",
  },
  {
    date: "Juin 2017 à Septembe 2017",
    entreprise: "Tipiak ",
    lieu: "Saint-Herblain",
    statut: "Agent de production",
    mission:
      "Réalisation des commandes quotidiennes, respect des protocoles d'hygienne et de sécurité",
    categorie: "autre",
  },
  /********** COIFFURE ***************/

  {
    date: "Février 2017 à Juin 2018",
    entreprise: "Sam's Barber ",
    lieu: "Dublin",
    statut: "Barbier",
    mission: "Stage en immersion dans le but d'apprendre l'Anglais",
    categorie: "coiffure",
  },
  {
    date: "Novembre 2016 à Février 2017",
    entreprise: "Shampoo",
    lieu: "Saint-Sebastien",
    statut: "Barbier",
    mission:
      "Recherche des besoins client, conseil, realisation des coupes et diférrentes techniques de coloration   ",
    categorie: "coiffure",
  },
  {
    date: "Septembre 2014 à Juin 2016",
    entreprise: "Saint-Algue",
    lieu: "Nantes",
    statut: "Apprenti - BP",
    mission: "Apprentissage des différentes techniques de coupe et coloration",
    categorie: "coiffure",
  },
  {
    date: "Septembre 2012 à Juin 2014",
    entreprise: "Saint-Algue",
    lieu: "Saint-Sebastien",
    statut: "Apprenti - CAP",
    mission: "Apprentissage des différentes technique de coupe et coloration",
    categorie: "coiffure",
  },
  {
    date: "Septembre 2010 à Juin 2012",
    entreprise: "Salon Saint-Joseph",
    lieu: "Saint Joseph de Porterie",
    statut: "Apprenti - CAP",
    mission: "Apprentissage des différentes techniques de coupe et coloration",
    categorie: "coiffure",
  },
];

export default dataCv;
